import {
  BaSeContainer,
  BaSeDataTable,
  BaSeDatePicker,
  BaSeIcon,
  BaSeInput,
  BaSeParagraph,
  BaSeRadio,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import React from 'react';
import { cpfMask } from '../../../../../../../utils/formatters/cpfMask';
import {
  AlignHeaderContainer,
  Container,
  HeaderContainer,
} from './generate-certificate-style';
import { useModule } from '../../../../../../../hooks/module/module';

// eslint-disable-next-line sonarjs/cognitive-complexity
function GenerateCertificateData({
  initialDate,
  finalDate,
  setFinalDate,
  setInitialDate,
  cargaHoraria,
  setCargaHoraria,
  data,
  setData,
  radioTypeSeminar,
  setRadioTypeSeminar,

  listTypeRadios, setListTypeRadios
}) {
  const currentDate = new Date();
  const YESTERDAY = new Date(currentDate.setDate(currentDate.getDate() - 1));
  const {moduleSelected} = useModule()

  const remove = React.useCallback(
    (value) => {
      const response = data.filter((item) => {
        return item !== value;
      });
      setData(response);
    },
    [data, setData],
  );
  const hasMutiple = () => {
    if (data.length > 1) {
      return {
        accessorKey: 'lixeira',
        header: 'Remover',
        mapper: ({ values }) => (
          <BaSeIcon
            name="trash-alt"
            size="16"
            onClick={() => remove(values)}
            description="icon-lightulb-als"
            color={BaSeTheme.colors.institucionais.cinzaSebrae30}
          />
        ),
      };
    }
    return {
      accessorKey: 'lixeira',
      header: '',
      mapper: ({ values }) => <></>,
    };
  };
  const configTable = [
    {
      accessorKey: 'name',
      header: 'Nome completo',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            {values.candidate.name}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'cpf',
      header: 'CPF',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          {cpfMask(values.candidate.cpf)}
        </BaSeSmall1>
      ),
    },
    hasMutiple(),
  ];

  const handleChangeWorkload = React.useCallback(
    (e) => {
      if (isNaN(+e) || e.includes('.') || e.includes(' ')) {
        return;
      }
      setCargaHoraria(e);
    },
    [setCargaHoraria],
  );

  return (
    <Container>
      <HeaderContainer>
        <BaSeParagraph color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          Lista de candidato(s) selecionado(s) para geração de certificado(s)
        </BaSeParagraph>
        <AlignHeaderContainer>
          <>
            <BaSeDatePicker
              startDate={initialDate}
              label="Data do Seminário"
              maxDate={YESTERDAY}
              onStartDateChange={setInitialDate}
              onBlur={(e) => {
                setInitialDate((date) => date);
              }}
              onSelect={(date) => {
                setInitialDate(date);
              }}
              placeholder="Data de início"
            />

            <BaSeDatePicker
              startDate={finalDate}
              isDisabled={!initialDate}
              //maxDate={new Date()}
              minDate={
                new Date(
                  new Date(initialDate).setDate(
                    new Date(initialDate).getDate() + 1,
                  ),
                )
              }
              onStartDateChange={setFinalDate}
              onBlur={(e) => {
                setFinalDate((date) => date);
              }}
              onSelect={(date) => {
                setFinalDate(date);
              }}
              placeholder="Data de término"
              label="  "
            />
          </>

          <div>
            <BaSeInput
              suffix=" horas"
              label="Carga horária"
              placeholder={`${cargaHoraria} horas`}
              value={cargaHoraria}
              onChange={handleChangeWorkload}
              inputMode="decimal"
              maxLength={9}
            />
          </div>
          {
            moduleSelected?.id === 1 && (
              <div>
                <BaSeParagraph color="#617385">Tipo de seminário</BaSeParagraph>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <BaSeRadio
                    checked={radioTypeSeminar === 5}
                    color="default"
                    id={5}
                    label="5 Dias"
                    name="FIVE_DAYS"
                    onChange={() => setRadioTypeSeminar(5)}
                    shape="circle"
                    size="medium"
                  />

                  <BaSeRadio
                    checked={radioTypeSeminar === 6}
                    color="default"
                    id={6}
                    label="6 Dias"
                    name="SIX_DAYS"
                    onChange={() => setRadioTypeSeminar(6)}
                    shape="circle"
                    size="medium"
                  />
                </div>
              </div>
            )
          }

        </AlignHeaderContainer>
      </HeaderContainer>
      <BaSeContainer
        withAutoScroll
        style={{ height: '30vh', margin: '10px 0' }}
      >
        <BaSeDataTable
          config={configTable}
          shadow="0"
          items={data}
          width="99%"
          hasHeader={false}
        />
      </BaSeContainer>
    </Container>
  );
}

export default GenerateCertificateData;
